<app-tab-header>
  @if (projectPlanningForm) {
  <div class="row">
    <form novalidate [formGroup]="projectPlanningForm">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label for="GroupSpudDate">Group Spud Date</label>
            <kendo-datepicker id="GroupSpudDate" class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="GroupSpudDate"></kendo-datepicker>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="GroupRigRelease">Group Rig Release</label>
            <kendo-datepicker id="GroupRigRelease" #GroupRigRelease class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="GroupRigRelease"></kendo-datepicker>
          </div>
        </div>
        <div kendoTooltip class="col-md-2">
          <div class="form-group">
            <label for="StartFrac">Start Frac</label>
            <kendo-datepicker id="StartFrac" #StartFrac class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="StartFrac"></kendo-datepicker>
          </div>
        </div>
        <div kendoTooltip class="col-md-2">
          <div class="form-group">
            <label for="EndFrac">End Frac</label>
            <kendo-datepicker id="EndFrac" class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="EndFrac"></kendo-datepicker>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="EarliestPOP">POP Date</label>
            <kendo-datepicker id="EarliestPOP" class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="EarliestPOP"></kendo-datepicker>
          </div>
        </div>
      </div>
    </form>
  </div>
  }
  <div class="row">
    <div class="col-md-2 planning-tasks-header">
      Planning Tasks
    </div>
    <div class="col-md-10">
      <div class="ms-auto" style="float: right">
        @if (loading) {
        <kendo-loader [type]="loader.type" [themeColor]="loader.themeColor" [size]="loader.size"></kendo-loader>
        }
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save" [disabled]="editedTasks.size == 0 || saving" (click)="savePlanningTasks()">Save</button>&nbsp;
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" [disabled]="editedTasks.size == 0 || saving" (click)="cancelChanges()"> Cancel</button>
      </div>
    </div>
  </div>
</app-tab-header>
@if (projectTab() && projectTab().ProjectId) {
<div kendoTooltip #tooltip="kendoTooltip" [showOn]="'hover'" filter='tr span' style="height:calc(100% - 60px)">
  <ag-grid-angular #agGridFF class="ag-theme-balham" style="height:100%;min-height:190px;" (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions.gridOptions"
    [stopEditingWhenCellsLoseFocus]="false"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>
}